import { createClient, type SupabaseClient } from '@supabase/supabase-js'

function createSupabaseBackend(): SupabaseClient {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

  if (!supabaseUrl || !supabaseAnonKey) {
    console.warn(
      'Supabase environment variables are not set. Auth and database features will not work.',
    )
  }

  return createClient(
    supabaseUrl || 'https://placeholder.supabase.co',
    supabaseAnonKey || 'placeholder',
  )
}

export const supabase: SupabaseClient = createSupabaseBackend()
